export enum UserManagementRoute {
  login = 'Login',
  register = 'Register',
  activateAccount = 'Activate Account',
  forgotPasswordRequest = 'Forgot Password Request',
  forgotPasswordConfirm = 'Forgot Password Confirm',
  changePassword = 'Change Password'
}
